var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{attrs:{"data":_vm.students}},[_c('el-table-column',{attrs:{"property":"user_code","label":"Mã học viên","width":"150"}}),_c('el-table-column',{attrs:{"property":"name","label":"Họ tên","width":"300"}}),_c('el-table-column',{attrs:{"property":"created_at","label":"Ngày đăng ký"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }